import React, { Component } from 'react';
import {connect} from 'react-redux';
import * as actionCreator from "../../../action/index.js"
import {Modal, Button,Tabs,Tab,ButtonToolbar,OverlayTrigger,Tooltip} from 'react-bootstrap';
class HowToUseDoorWindowInDevice extends React.Component {

render() {

    return (
       <div>
           <Modal centered show={this.props.const_var.isShowDoorwindowmobile} backdrop='static' keyboard={false} dialogClassName= "react-modal "  backdropClassName="ract-modal-pre-parent " >   
           
            <button className="close" onClick={this.props.handleCloseBuildingModal}><span className="icon-close"></span></button>
            <Modal.Body className="text-center">    

              <p>1 - <span className="text-primary">Double Tap</span> on the component to <span className="text-primary">Move/Place</span></p>
              <p>2 - <span className="text-primary">Double Tap</span> outside of the building to <span className="text-primary">Lock/Deselect</span></p>
            
             <aside className="mt-4">
                <a style={{width: "150px"}} className="btn btn-secondary mt-4" onClick={this.props.handleCloseBuildingModal}>Ok</a>
             </aside>
            
            </Modal.Body>
                 
        </Modal>
        </div>
    )
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}


export default connect(
  mapStoreToProps,
  actionCreator
)(HowToUseDoorWindowInDevice);